import { Text } from "@mantine/core";
import { L2KCaptionProps } from "./types";
import { CAPTION_STYLE, COLORS } from "./constants";

/**
 * L2KCaption - Small caption text for credits, metadata, timestamps
 * Uses Public Sans font
 * Responsive sizing: 12px → 14px across 320px → 1920px viewports
 */
export function L2KCaption({
  children,
  variant = "tertiary",
  style,
  ...props
}: L2KCaptionProps) {
  // Get color based on variant (no gradient support for captions)
  const color = COLORS[variant];

  return (
    <Text
      style={{
        fontSize: CAPTION_STYLE.fontSize,
        lineHeight: CAPTION_STYLE.lineHeight,
        letterSpacing: CAPTION_STYLE.letterSpacing,
        fontWeight: CAPTION_STYLE.fontWeight,
        fontFamily: CAPTION_STYLE.fontFamily,
        color: color,
        margin: 0,
        ...style,
      }}
      {...props}
    >
      {children}
    </Text>
  );
}
